module.exports = __webpack_public_path__ + "img/selected7-min.08289026.png";